import { render, staticRenderFns } from "./ActivateTaxPlan.vue?vue&type=template&id=796d5aa4&scoped=true&"
import script from "./ActivateTaxPlan.vue?vue&type=script&lang=js&"
export * from "./ActivateTaxPlan.vue?vue&type=script&lang=js&"
import style0 from "./ActivateTaxPlan.vue?vue&type=style&index=0&id=796d5aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d5aa4",
  null
  
)

export default component.exports